export enum BULK_MANAGEMENT_FORM_TYPE {
  SWITCH_PROTRACK = 'switchProTrack',
  STOP_PROTRACK = 'stopProTrack',
  DELETE_USERS = 'deleteUsers',
}
